/* Get media constraints */
function getMediaConstraints() {
  var videoConstraints = {
    video: true,
    audio: false,
    facingMode: "user",
  };
  return videoConstraints;
}

export function checkCameraStatus() {
  return new Promise((resolve) => {
    navigator.mediaDevices
      .getUserMedia(getMediaConstraints()) //get permisson from user
      .then((stream) => {
        stream.getVideoTracks()[0].stop();
        resolve(null);
      })
      .catch((error) => {
        if (error.name === "NotReadableError") {
          resolve(
            "It looks like another app is using the camera already. Please turn off the camera in another app and click on the Retry button."
          );
        } else if (error.name === "NotFoundError") {
          resolve("We cannot find your camera. Please connect your camera and click on the Retry button.");
        } else if (error.name === "NotAllowedError") {
          resolve(
            "Please change the permission settings on your browser to allow access to camera and click on the Retry button."
          );
        } else {
          resolve("We cannot access your camera. Please check your camera and click on the Retry button.");
        }
      });
  });
}

export async function startCamera(webcamElement) {
    return new Promise((resolve, reject) => {    
      navigator.mediaDevices.getUserMedia(getMediaConstraints())
        .then(stream => {
            const stream_settings = stream.getVideoTracks()[0].getSettings();
            webcamElement.srcObject = stream;
            webcamElement.style.transform = "scale(-1,1)";
            webcamElement.play();
            resolve(stream_settings);
        })
        .catch(error => {
            reject(error);
        });
    });
  }
